import React from "react";
import { useEffect } from "react";
import Tambah from "../../components/Pinjam/Tambah";

const TambahBT = () => {
  useEffect(() => {
    document.title = "Si TASIK - Tambah BT";
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="p-6">
      <Tambah/>
    </div>
  );
};

export default TambahBT;
